<template>
  <div
    :class="`card card-reward ${shaking ? 'animate_shake' : ''}`"
    @contextmenu="rewardFinal ? $emit('edit', kid) : null"
    @click="redeem()"
    v-if="reward"
    :updater="reward"
    :style="`background-image: url(${reward.get('image') || '/images/reward.jpeg'});`"
  >
    <div class="card-header">
      <center>
        <h3>{{ rewardFinal.get("name") }}</h3>
      </center>
    </div>
    <div class="card-footer pb-inner">
      <span class="progressInfo"
        >{{ kid.get("points") }}/{{ kid.get("rewardValue") }} points</span
      >
      <progress
        class="progress-bar"
        v-if="kid.get('points') < kid.get('rewardValue')"
        :value="kid.get('points')"
        :max="kid.get('rewardValue')"
      ></progress>
      <p
        class="btn rewardItem"
        @click="$emit('redeem')"
        v-else-if="!$route.path.includes('kids')"
        style="z-index: 9001"
        role="button"
      >
        Redeem
      </p>
      <div class="btn" style="z-index: 9001" role="button" aria-disabled="true" v-else>
        {{ $t("pages.kids.goodJob") }}
      </div>
    </div>
    <div class="overlay"></div>
  </div>
  <div v-else class="card">
    <div>
      <center>
        <h3>{{ $t("reward.title") }}</h3>
        <p>
          {{ $t("reward.subtitle") }}
          <br />
          {{
            $tc("reward.currentPoints", kid.get("points"), { count: kid.get("points") })
          }}
        </p>
      </center>
    </div>
    <div class="pb-inner hide-on-watch">
      <button
        class="btn btn-wide"
        v-if="mode !== 'kids'"
        @click="$router.push('/rewards')"
      >
        {{ $t("reward.addReward") }}
      </button>
    </div>
    <div class="overlay"></div>
  </div>
</template>
<script>
export default {
  props: ["kid", "mode", "reward"],
  data() {
    return {
      isCustom: false,
      rewardFinal: null,
      shaking: false,
    };
  },
  mounted() {
    this.$props.reward.fetch().then((x) => {
      this.$data.rewardFinal = x;
    });
  },
  watch: {
    rewardFinal: function () {
      this.$props.reward.fetch().then((x) => {
        this.$data.rewardFinal = x;
      });
    },
  },
  computed: {
    percentageComplete() {
      return this.$props.kid.get("points") / this.$props.kid.get("rewardValue");
    },
  },
  methods: {
    async redeem() {
      const child = this.$root.$data.kids[this.$root.$data.selectedChild];
      if (child.get("points") - child.get("rewardValue") < 0) {
        this.$data.shaking = true;
        setTimeout(() => (this.$data.shaking = false), 1500);
        return;
      }
      const x = await ModernModals.prompt(
        `Would you like to redeem this reward for ${child.get("name")}?`
      );
      if (x) {
        child.set("points", child.get("points") - child.get("rewardValue"));
        child.get("customReward").destroy();
        child.set("customReward", null);
        child.save();
        VueInstance.initLoadChores();
        VueInstance.$children[0].$children.forEach((x) => x.$forceUpdate());
      }
    },
    openAddReward() {
      AddRewardModal.open();
    },
    getProgess(kid, isPositive) {
      let pointsAsPercentPos = kid
        ? (kid.get("points") / kid.get("rewardValue")) * 100
        : 0;
      let pointsAsPercentNeg = 100 - pointsAsPercentPos;
      return isPositive ? pointsAsPercentPos : pointsAsPercentNeg;
    },
  },
};
</script>
